import React, { PureComponent } from 'react';
import { object, func } from 'prop-types';
import Card from '../../../../components/Card/Card';
import OfferCardInfo from './OfferCardInfo';
import OfferCardControls from '../../../../components/Offer/OfferCardControls';
import OfferCardItem from '../../../../components/Offer/OfferCardItem';

class OfferCard extends PureComponent {
    static propTypes = {
        offer: object.isRequired,
        onRequestOfferAccess: func.isRequired,
        onRefuseOfferAccess: func.isRequired,
        onFlowCreate: func.isRequired,
    };

    render() {
        const { offer, onRequestOfferAccess, onRefuseOfferAccess, offerSettings, onFlowCreate } = this.props;

        return (
            <Card.Body>
                <div className="offer-card">
                    <OfferCardInfo
                        currencies={offer.currencies}
                        stats={offer.stats}
                        description={{ description: offer.description, full_description: offer.full_description }}
                        title={offer.title}
                        id={offer.id}
                        url={offer.url}
                        modifies={offer.modifies}
                        pic={`${offerSettings['images_path']}${offer.images ? offer.images[100] : ''}`}
                    >
                        <OfferCardControls
                            offerId={offer.id}
                            isMy={offer.modifies.is_my}
                            hasAccess={offer.admit.has_access}
                            hasPromo={offer.hasPromo}
                            onRequestOfferAccess={onRequestOfferAccess}
                            onRefuseOfferAccess={onRefuseOfferAccess}
                            onFlowCreate={onFlowCreate}
                        />
                    </OfferCardInfo>

                    {/* {offer.description && (
                        <OfferCardItem
                            id="offer.overview"
                            className="offer-overview"
                            defaultMessage="Overview"
                            html={offer.description}
                        />
                    )}

                    {offer.full_description && (
                        <OfferCardItem
                            id="offer.description"
                            defaultMessage="Description"
                            className="offer-description"
                            html={offer.full_description}
                        />
                    )} */}
                </div>
            </Card.Body>
        );
    }
}

export default OfferCard;